/**
 * xiaoxia
 */


import React, {Component} from 'react';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router'
import axios from 'axios';
import qs from 'qs';
import {Mask} from 'react-weui';
import {renderMoney, getJsonFromUrl} from '../utils';
import redpacketImg from '../images/coupon/redpacket.png'
import redpacketOpenImg from '../images/coupon/redpacket-open.png'
import closeImg from '../images/coupon/close.png'


import '../styles/ReceiveCoupon.css';
import { setEvent } from '../services';


class ReceiveCoupon extends Component {
    constructor(){
        super()
        this.state = {
            show: false,
            coupon: null,
            isOpenAnimate: false,
            isGetCouponDone : false,
            isShowCouponPrice: false,
        }
        this.onRequestClose = this.onRequestClose.bind(this)
        this.onReceive = this.onReceive.bind(this)
        new Image().src = redpacketImg
        new Image().src = redpacketOpenImg
        this.isNewCoupon = getJsonFromUrl().is_new_coupon == 1
    }

    componentDidMount () {
        // this.receiveCoupon(this.props)
        this.tjData('wk_lecture-show-redpack', 'wk_channel-show-redpack')
    }

    onRequestClose(){
        this.setState({
            show: false
        })
    }

    useCoupon(coupon){
        const {scope} = this.props
        if(scope === 'lecture'){
            this.props.dispatch({
                type: 'LECTURE_SET_DISCOUNT',
                payload: coupon
            });
            this.props.dispatch({
                type: 'LECTURE_SHOW_DISCOUNT_PAY_PANEL'
            });
        }else if(scope === 'channel' || scope === 'cps_cash'){
            // this.props.dispatch({
            //     type: 'CHANNEL_SET_DISCOUNT',
            //     payload: coupon
            // });
            this.props.dispatch({
                type: 'CHANNEL_SHOW_PAY_PANEL'
            });
            this.props.dispatch({
                type: 'CHANNEL_SET_DISCOUNT',
                payload: coupon
            });
        }else if (scope === 'liveroom'){
            if (!sessionStorage.getItem(`coupon_${this.props.target.id}`)){
                this.context.page.showAlert('领取成功');
            }
            sessionStorage.setItem(`coupon_${this.props.target.id}`, '1');
            /*this.context.page.showAlert('领取成功', () => {
                browserHistory.replace('/account/coupons');
            });*/
        }
    }

    // 专栏专用的领取
    _onReceive(){
        this.setState({ isOpenAnimate: true })
        // setTimeout(() => {
        //     this.setState({ isGetCouponDone: true, isShowCouponPrice: true })
        // }, 2000)
        setTimeout(() => {
            axios.post(`/api/coupon/accept`, qs.stringify(this.queryParams)).then((res) => {
                if (res.data.code === 0) {
                    const {coupon} = res.data.data
                    localStorage.setItem('lastCoupon', JSON.stringify(coupon))
                    this.props.dispatch({
                        type: 'NEW_COUPON_DATA',
                        payload: coupon
                    })
                    this.props.dispatch({
                        type: 'CHANNEL_SET_DISCOUNT',
                        payload: coupon
                    })
                    this.setState({ isGetCouponDone: true, isShowCouponPrice: true })
                    // this.useCoupon(coupon)
                } else {
                    this.context.page.showAlert(res.data.msg)
                }
            })
        }, 1000)
        this.tjData('wk_lecture-receive-redpack', 'wk_channel-receive-redpack')
    }

    // 原领取
    onReceive(){
        this.setState({
            show: false
        })

        this.context.page.showLoading()
        axios.post(`/api/coupon/accept`, qs.stringify(this.queryParams)).then((res) => {
            this.context.page.hideLoading()
            this.setState({
                show: false
            })
            if (res.data.code === 0) {
                const {coupon} = res.data.data
                localStorage.setItem('lastCoupon', JSON.stringify(coupon))
                this.props.dispatch({
                    type: 'COUPON_SET_AVAILABLE',
                    payload: {
                        coupon: coupon
                    }
                })
                this.useCoupon(coupon)
            } else {
                this.context.page.showAlert(res.data.msg)
            }
        })
    }

    componentWillUpdate(nextProps, nextState){
        if(this.props.code !== nextProps.code && nextProps.code){
            this.receiveCoupon(nextProps)
        }
    }

    
    receiveCoupon(props){
        const {target, code, scope} = props

        if (!sessionStorage.getItem(`coupon_${target.id}`)){
            this.context.page.showLoading()
        }
        this.queryParams = {
            scope: scope,
            code: code
        }
        if(scope === 'lecture'){
            this.queryParams.lecture_id = target.id
        }else if(scope === 'channel'){
            this.queryParams.channel_id = target.id
        }else if(scope === 'vip' || scope === 'liveroom'){
            this.queryParams.liveroom_id = target.id
        }else if (scope === 'cps_cash') {
            this.queryParams.target_id = target.id
        }
        axios.get(`/api/coupon/query`, {params: this.queryParams}).then(res => {
            this.context.page.hideLoading()
            if (res.data.code === 0) {
                const {data} = res.data
                const status = data.accept_status
                if(status === 'unavailable'){
                    this.context.page.showAlert("手慢了，优惠券已被领完。")
                }else if(status === 'expired'){
                    this.context.page.showAlert("优惠券已过期。")
                }else if(status === 'available'){
                    console.log('hi')
                    this.setState({
                        show: true,
                        coupon: data.coupon,
                        scope: scope
                    })
                }else if(status === 'active'){
                    this.useCoupon(res.data.data.coupon)
                }
            } else {
                this.context.page.showAlert(res.data.msg)
            }
        });
    }

    getScopeName(){
        switch(this.state.scope){
            case 'channel':
                return '专栏优惠券'
            case 'lecture':
                return '课程优惠券'
            case 'liveroom':
                return '直播间通用券'
            case 'weike':
                return '荔枝微课现金券'
        }
    }

    getDeadline(){
        return '2017-09-01'
    }

    //下方的适用范围
    getScopeDescription(){
        switch(this.state.scope){
            case 'channel':
                return `专栏【${this.state.coupon.object_name}】`
            case 'lecture':
                return `课程【${this.state.coupon.object_name}】`
            case 'liveroom':
                return `直播间【${this.state.coupon.object_name}】`
            case 'weike':
                return '适用于荔枝微课所有内容'
        }
    }

    getPromoteSource(){
        const {coupon} = this.state
        const {scope} = this.props

        let scopeText = scope === 'lecture' ? '课程' : '专栏'

        let scopeType = '';
        switch(this.state.scope){
            case 'channel':
                scopeType = `专栏【${coupon.object_name}】`;
                break;
            case 'lecture':
                scopeType = `课程【${coupon.object_name}】`;
                break;
            case 'liveroom':
                scopeType = `直播间【${this.state.coupon.object_name}】`;
                break;
            case 'weike':
                scopeType = '适用于荔枝微课所有内容';
                break;
        }
        return <div>
            <p>适用范围</p>
            <p className="text-ellipsis">{scopeType}</p>
        </div>
    }

    onClickUse (coupon) {
        this.setState({ show: false })
        this.useCoupon(coupon)
        this.tjData('wk_lecture-click-redpack', 'wk_channel-click-redpack')
    }

    tjData(lectureEvent, channelEvent) {
        if (location.pathname.indexOf('lecture') > -1) {
            setEvent({name: lectureEvent})
        }
        if (location.pathname.indexOf('channel') > -1) {
            setEvent({name: channelEvent})
        }
    }

    render() {
        if(!this.state.show) return null

        const {coupon, scope, isOpenAnimate, isGetCouponDone, isShowCouponPrice} = this.state
        const { liveroom } = this.props

        return(
            <div className="receive-coupon">
                <Mask onClick={this.onRequestClose} />
                {/* 开红包效果的优惠券 */}
                {
                    (scope === 'channel' || scope === 'cps_cash') && this.isNewCoupon && (
                        <div className="_coupon-dialog">
                            <div className="redpacket-wrap" style={{backgroundImage: `url(${redpacketImg})`}}>
                                <div className="avatar" style={{backgroundImage: `url(${liveroom.avatar_url})`}}>
                                </div>
                                <div className="name text-ellipsis">{liveroom.name}</div>
                                <div className="intro">发了一个红包，价值连城</div>
                                <div className={`big-title ${isShowCouponPrice ? 'hide' : ''}`}>正在派红包，快来领！</div>
                                <div className={`money-wrap ${isShowCouponPrice ? 'show' : ''}`}>
                                    <span className="money">{+renderMoney(coupon.price)}</span>
                                    <span> 元</span>
                                </div>
                                <div className={`receive-btn ${isShowCouponPrice ? 'show' : ''}`} onClick={e => this.onClickUse(coupon)}>
                                    立即使用
                                </div>
                                <div 
                                    onClick={() => this._onReceive()} 
                                    className={`redpacket-open ${isOpenAnimate ? 'animate' : ''} ${isGetCouponDone ? 'out' : ''}`}
                                >
                                    <img src={redpacketOpenImg} alt=""/>
                                </div>
                                <div className={`close ${isShowCouponPrice ? 'hide' : ''}`} onClick={this.onRequestClose}>
                                    <img src={closeImg} alt=""/>
                                </div>
                                <div className={`bottom-text ${isShowCouponPrice ? 'hide' : ''}`}>已派出5,963,712元红包，派完为止</div>
                            </div>
                        </div>
                    )
                }

                {/* 弹窗式优惠券 */}
                {
                    !this.isNewCoupon && (
                        <div className="coupon-dialog">
                            <div className="title">
                                领取优惠券
                            </div>
                            <div className="card">
                                <div className="top">   
                                    <span className="name">
                                        {this.getScopeName()}
                                    </span>
                                    <span className="money">
                                        ¥{renderMoney(coupon.price)}
                                    </span>
                                </div>
                                <div className="bottom">
                                    <div>{this.getPromoteSource()}</div>
                                </div>
                            </div>
                            <div className="tips">
                                <p>优惠活动：{coupon.coupon_name}</p>
                                {coupon.deadline_enabled &&
                                <p>有效期至：{coupon.deadline}</p>
                                }
                                {
                                    coupon.threshold_enabled && (
                                        <p>使用条件：满￥{renderMoney(coupon.threshold_price)}可用</p>
                                    )
                                }
                            </div>
                            <div className="bottom">
                                <button className="receive-btn" onClick={this.onReceive}>领取</button>
                            </div>
                        </div>
                    )
                }
            </div>
        )
    }
}


ReceiveCoupon.contextTypes = {
    page: React.PropTypes.object
};


export default connect((state) => ({
    code: state.coupon.code,
    scope: state.coupon.scope,
    target: state.coupon.target,
    liveroom: state.coupon.liveroom,
}))(ReceiveCoupon)




// WEBPACK FOOTER //
// ./src/components/ReceiveCoupon.js